export enum UserProfileTypes {
    Account = "Account",
    Addresses = "Addresses",
    OrderHistory ="OrderHistory",
}